<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics

========================================================================================== -->

<template>
  <div id="course-page">
    <vs-alert :active.sync="errorOccurred" color="danger" title="Course Not Found">
      <span>Course record with id: {{ $route.params.courseId }} not found. </span>
      <span> <span>Check </span><router-link :to="{ name: 'courses' }" class="text-inherit underline">Course Selector</router-link> </span>
    </vs-alert>

    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <div class="vx-card rounded-lg flex w-full p-4">
          <div class="flex justify-between w-full">
            <div class="flex flex-wrap content-center pl-2">
              <h1 class="font-bold text-white w-full" style="font-size: 2.5rem" v-if="courseData">{{ courseData.name }}</h1>
              <h2 class="mb-2 text-white font-light w-full" v-if="courseData">Mass Course Report</h2>
            </div>
            <div class="flex w-full justify-end gap-x-4">
              <img
                :src="
                  courseData.thumbnail !== null
                    ? courseData.thumbnail
                    : 'https://connect-cdn.intellectualpoint.com/assets/images/misc/default-placeholder.png'
                "
                class="rounded hidden lg:block"
                style="max-width: 100px; max-height: 100px; width: 20%"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row" v-if="!courseCompletionData">
      <div class="vx-col w-full">
        <vx-card>
          <h4 class="font-light mb-2">Enter Emails To Generate Report</h4>
          <vs-textarea height="600px" v-model="massEmails" class="mb-4" />
          <vs-button type="gradient" @click="generateReport()">Generate Report</vs-button>
        </vx-card>
      </div>
    </div>

    <div class="vx-row" v-if="courseCompletionData" id="CourseViewMassProgress">
      <div class="vx-col w-full">
        <vs-table :data="courseCompletionData.users" max-items="10" search class="main-border rounded-lg" pagination>
          <template slot="header">
            <h3 class="ml-4 mr-6">Generated Report - ({{ courseCompletionData.usersFound }}) Students</h3>
            <vs-button class="w-fit font-bold" size="small" icon="icon-download" icon-pack="feather" color="primary" @click="exportData"
              >Export Data
            </vs-button>
          </template>

          <template slot="thead">
            <vs-th>Student</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Final Grade</vs-th>
            <vs-th>Final Percentage</vs-th>
            <vs-th>ExamEdge Grade</vs-th>
            <vs-th>ExamEdge Assignments</vs-th>
            <vs-th>FlashCards Grade</vs-th>
            <vs-th>Labs Grade</vs-th>
            <!-- <vs-th>View More Details</vs-th> -->
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="attach in data" :key="attach.id" class="text-lg">
              <vs-td :data="attach"> {{ attach.firstName }} {{ attach.lastName }} </vs-td>

              <vs-td :data="attach.email">
                {{ attach.email }}
              </vs-td>

              <vs-td
                :data="attach.progress.final"
                class="font-bold"
                style="font-size: 1.3rem"
                :class="getGradeClass(attach.progress.final.grade)"
              >
                {{ attach.progress.final.grade }}
              </vs-td>

              <vs-td
                :data="attach.progress.final"
                class="font-bold"
                style="font-size: 1.3rem"
                :class="getGradeClass(attach.progress.final.grade)"
              >
                {{ attach.progress.final.percent }}%
              </vs-td>

              <vs-td :data="attach.progress.examedge"
                >{{ attach.progress.examedge.totalGrade }} ({{ attach.progress.examedge.totalGradePercent }})%
              </vs-td>

              <vs-td :data="attach.progress.examedge"
                >{{ attach.progress.examedge.passedCount }} / {{ attach.progress.examedge.total }} Complete
              </vs-td>

              <vs-td :data="attach.progress.flashcards">
                {{ attach.progress.flashcards.totalGrade }} ({{ attach.progress.flashcards.totalGradePercent }}%)
              </vs-td>

              <vs-td :data="attach.progress.labs">
                {{ attach.progress.labs.totalGrade }} ({{ attach.progress.labs.totalGradePercent }}%)
              </vs-td>

              <!-- <vs-td :data="attach.progress.examedge">
                <vs-button
                  color="success"
                  size="small"
                  type="border"
                  icon-pack="feather"
                  icon="icon-file-text"
                  class="w-full"
                  @click="openProgress(attach.id)"
                >
                  View Details
                </vs-button>
              </vs-td> -->
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import LottieAnimation from '../../../../../components/lottie/LottieAnimation';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      courseData: null,
      errorOccurred: false,

      massEmails: '',
      courseCompletionData: null,
      courseCompletionTotal: null,
      totalSetsPercentage: null,

      extractedExportData: {},
    };
  },
  components: {
    VueApexCharts,
    LottieAnimation,
  },
  computed: {
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse;
    },
  },
  methods: {
    loadCourseInfo(id) {
      this.$http
        .get(`course/${id}`)
        .then((response) => {
          if (response.data) {
            this.courseData = response.data;
          }
        })
        .catch(() => {});
    },
    openProgress(uid) {
      window.open(`/a/users/${uid}/progress/${this.courseData.id}`, '_blank');
    },
    generateReport() {
      this.$vs.loading();
      const emailsArray = this.massEmails.split('\n').filter((email) => email.trim() !== '');

      this.$http
        .post('compliance/report/mass', { courseId: this.courseData.id, emails: emailsArray })
        .then((response) => {
          if (response.data) {
            this.$vs.loading.close();
            this.courseCompletionTotal = response.data;
            this.courseCompletionData = this.courseCompletionTotal;
            this.courseCompletionData.users.sort((a, b) => b.progress.final.percent - a.progress.final.percent);
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Report Could Not Be Generated',
            text: 'Please email cameron@intellectualpoint.com for more information.',
            color: 'danger',
            position: 'top-right',
          });
        });
    },
    // async exportData() {
    //   const workbook = new ExcelJS.Workbook();
    //   const worksheet = workbook.addWorksheet('Report', { properties: { tabColor: { argb: 'FFC0000' } } });

    //   const currentDate = new Date();
    //   const formattedDate = `${currentDate.getMonth() + 1}-${currentDate.getDate()}-${currentDate.getFullYear()}`;
    //   const course = this.courseCompletionData.course;

    //   // Define colors for grades with alternating shades
    //   const gradeColors = {
    //     A: { light: 'FFC6EFCE', dark: 'FFB7DEAC' },
    //     B: { light: 'FF9FC5E8', dark: 'FF8FB0D9' },
    //     C: { light: 'FFF9CB9C', dark: 'FFE8B989' },
    //     D: { light: 'FFE06666', dark: 'FFC55959' },
    //     F: { light: 'FFE06666', dark: 'FFC55959' }, // Assuming F or below should also be light red
    //   };

    //   // Headers
    //   const headers = ['First Name', 'Last Name', 'Email', 'Final Percent', 'Final Grade'];
    //   // You'll dynamically add headers based on the maximum assignments
    //   const maxAssignments = this.courseCompletionData.users.reduce((max, user) => {
    //     const examedgeAssignments = user.progress.examedge ? Object.keys(user.progress.examedge.assignments).length : 0;
    //     return Math.max(max, examedgeAssignments);
    //   }, 0);
    //   for (let i = 1; i <= maxAssignments; i++) {
    //     headers.push(`ExamEdge Assignment ${i}: Grade`, `ExamEdge Assignment ${i}: Percent`, `ExamEdge Assignment ${i}: Passed`);
    //   }
    //   headers.push('Simulation Grade', 'Simulation Percent'); // Add headers for other data fields if needed

    //   // Set worksheet headers
    //   worksheet.columns = headers.map((header) => ({ header, key: header, width: 20 }));

    //   // Add user data and apply styles
    //   this.courseCompletionData.users.forEach((user, index) => {
    //     const userRow = worksheet.getRow(index + 2); // Plus 2 because Excel is 1-indexed and there is a header row

    //     // Apply alternating row colors and populate row data
    //     Object.keys(user).forEach((key, colIndex) => {
    //       const cell = userRow.getCell(colIndex + 1);
    //       const grade = user['Final Grade'];
    //       const gradeColor = gradeColors[grade]
    //         ? index % 2 === 0
    //           ? gradeColors[grade].light
    //           : gradeColors[grade].dark
    //         : gradeColors['F'].light;
    //       cell.value = user[key];
    //       cell.fill = {
    //         type: 'pattern',
    //         pattern: 'solid',
    //         fgColor: { argb: gradeColor },
    //       };
    //       // Bold the grade cell
    //       if (key === 'Final Grade') {
    //         cell.font = { bold: true };
    //       }
    //     });
    //   });

    //   // Add course details in the header
    //   const detailsStartColumn = worksheet.columnCount + 2; // Start 2 columns after the last user data column
    //   const courseDetailsRow = worksheet.getRow(1);
    //   courseDetailsRow.getCell(detailsStartColumn).value = 'Course Name';
    //   courseDetailsRow.getCell(detailsStartColumn + 1).value = course.name;
    //   courseDetailsRow.getCell(detailsStartColumn).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
    //   // Continue adding course details...

    //   // Write the workbook to a buffer and then save using FileSaver
    //   const buffer = await workbook.xlsx.writeBuffer();
    //   const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //   saveAs(blob, `CourseReport_${formattedDate}.xlsx`);
    // },
    exportData() {
      const currentDate = new Date();
      const formattedDate = `${currentDate.getMonth() + 1}-${currentDate.getDate()}-${currentDate.getFullYear()}`;

      const mappedData = this.courseCompletionData.users.map((user) => {
        let userData = {
          'First Name': user.firstName,
          'Last Name': user.lastName,
          Email: user.email,
          'Final Percent': user.progress.final.percent,
          'Final Grade': user.progress.final.grade,
        };

        if (user.progress.examedge) {
          userData['ExamEdge Grade'] = user.progress.examedge.totalGrade;
          userData['ExamEdge Percent'] = user.progress.examedge.totalGradePercent;

          // Map assignments
          Object.keys(user.progress.examedge.assignments).forEach((assignmentName, index) => {
            const assignment = user.progress.examedge.assignments[assignmentName];
            userData[`ExamEdge Assignment ${index + 1}: Grade`] = assignment.bestGrade;
            userData[`ExamEdge Assignment ${index + 1}: Percent`] = assignment.bestPercent;
            userData[`ExamEdge Assignment ${index + 1}: Status`] = assignment.passed ? 'Passed' : 'Failed';
          });
        }

        if (user.progress.simulations) {
          userData['Simulation Grade'] = user.progress.simulations.totalGrade;
          userData['Simulation Percent'] = user.progress.simulations.totalGradePercent;
        }

        if (user.progress.flashcards) {
          userData['FlashCards Grade'] = user.progress.flashcards.totalGrade;
          userData['FlashCards Percent'] = user.progress.flashcards.totalGradePercent;
        }

        if (user.progress.labs) {
          userData['Labs Grade'] = user.progress.labs.totalGrade;
          userData['Labs Percent'] = user.progress.labs.totalGradePercent;
        }

        return userData;
      });

      const excelFileName = `MCR - Students.xlsx`;
      const data = XLSX.utils.json_to_sheet(mappedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, `Mass Course Report - ${formattedDate}`);
      XLSX.writeFile(wb, excelFileName);
    },
    getGradeClass(letter) {
      if (['A+', 'A', 'A-'].includes(letter)) return 'text-success';
      if (['B+', 'B', 'B-'].includes(letter)) return 'text-warning';
      if (['C+', 'C', 'C-'].includes(letter)) return 'text-warning';
      if (['D+', 'D', 'D-'].includes(letter)) return 'text-danger';
      if (letter === 'F') return 'text-danger';
      return '';
    },
  },
  beforeMount() {
    this.loadCourseInfo(this.$route.params.courseId);
  },
  watch: {},
};
</script>

<style lang="scss">
#CourseViewMassProgress {
  .vs-table--header {
    border-bottom: 1px solid #222f44;
  }

  .vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead tr {
    border-bottom: 1px solid #222f44 !important;
  }

  .vs-con-table .vs-con-tbody .vs-table--tbody-table tr {
    border-bottom: 1px solid #222f44 !important;
    border-radius: 0rem !important;
  }

  .vs-pagination--nav .vs-pagination--buttons {
    background: #222f44;
    color: #ffffff;
  }
}
</style>
